import React from 'react';
import { MapPin } from 'lucide-react';
import { locations } from '../mockData';

const Locations = () => {
  return (
    <section className="py-16 bg-gray-700 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-12">
          Locations Served
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {locations.map((location) => (
            <div key={location.id} className="flex items-start space-x-4">
              <MapPin className="text-teal-400 flex-shrink-0 mt-1" size={28} />
              <div>
                <h3 className="text-xl font-bold mb-2">{location.name}</h3>
                <p className="text-gray-300 leading-relaxed">
                  {location.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Locations;